import React, { useEffect, useState } from 'react'
import moment from "moment";
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
// let token = JSON.parse(localStorage.getItem('key'));
function InOutComp({ att_date, leave_status, user_id, count, status_check, start_time, end_time }) {
    const [inOut, setInOut] = useState([])
    const [firstIntime, setFirstIntime] = useState('')
    const [lastOuttime, setLastOuttime] = useState('')
    const [ssss, setSsss] = useState('');
    const [totalminuts, setTotalminuts] = useState(0);



    const gettoken = localStorage.getItem('key');
    // const token_data = jwt_decode(gettoken);
    const newToken = JSON.parse(gettoken);
    const token = newToken.value;


    useEffect(() => {
        getInOut(att_date, user_id)
    }, [att_date, count, start_time, end_time])
    // console.log('count')
    // console.log(count)
    // console.log('count')
    var totalMinut = 0
    const getInOut = async (att_date, user_id) => {
        // alert(att_date)
        // alert(user_id)
        let token = JSON.parse(localStorage.getItem('key'));
        const response = await fetch(SERVER_URL + `api/attendance/day-in-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ att_date: moment(att_date).format("YYYY-MM-DD"), user_id: user_id }),
            }).then(res => res.json())
            .then(data => {
                // console.log('count')
                // console.log(data.data)
                // console.log('count')
                // setInOut(data?.data)
                var tmp = 0;
                var total_hrs = 0;
                for (var i = 0; i < data?.data?.length; i++) {
                    setFirstIntime(data?.data[data?.data.length - 1]?.start_time)
                    setLastOuttime(data?.data[0].end_time)



                    const createdDate = moment(data?.data[i].att_date).format('YYYY-MM-DD');
                    const updatedDate = moment(data?.data[i].updated_on).format('YYYY-MM-DD');
                    const timeIn = data?.data[i].start_time
                    const timeOut = data?.data[i].end_time


                    var intime = new Date(createdDate + ' ' + timeIn);
                    var outtime = new Date(updatedDate + ' ' + timeOut);


                    var diffInSeconds = Math.abs(intime - outtime) / 1000;
                    // var days = Math.floor(diffInSeconds / 60 / 60 / 24);
                    var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
                    var minutes = Math.floor(diffInSeconds / 60 % 60);
                    // var seconds = Math.floor(diffInSeconds % 60);
                    // var milliseconds = Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);





                    var startTime = moment(timeIn, 'hh:mm:ss a');
                    var endTime = moment(timeOut, 'hh:mm:ss a');

                    var totalHours = (endTime.diff(startTime, 'hours'));
                    var totalMinutes = endTime.diff(startTime, 'minutes');
                    tmp = tmp + minutes
                    total_hrs = total_hrs + hours

                }
                // totalMinut = tmp%60
                // var clearMinutes = tmp % 60;
                // setTotalminuts(totalMinut)
                // var minutformat = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
                // var totalHoursformat = parseInt(tmp / 60) < 10 ? '0' + parseInt(tmp / 60) : parseInt(tmp / 60);
                // setSsss(totalHoursformat + " : " + minutformat);
                // var HRS_format_set = total_hrs <= 9 ? '0' + total_hrs : total_hrs
                // var MNTS_format_set = tmp<=9?'0'+tmp:tmp 

                var HRS = total_hrs + Math.floor(tmp / 60)
                var MNTS = tmp % 60


                // console.log("MNTS_format_set /", Math.floor(MNTS / 60))
                // console.log("MNTS_format_set %", MNTS % 60)

                // var HRS = MNTS_format_set >= 60 ? HRS_format_set + Math.floor(MNTS_format_set / 60) : HRS_format_set
                // var MINUTS =

                // var HRS = HRS_format_set+Math.floor(MNTS_format_set/60)<10?'0'+HRS_format_set+Math.floor(MNTS_format_set/60):''
                setSsss(HRS + ':' + MNTS)
                // console.log(totalMinut) < 10 ? "0" + HRS : HRS

            })
    }
    return (
        <>
            {status_check == 1 && leave_status === 0  ? <span><i className="icon icon-clock"></i>{ssss} HRS</span> : ''}
            {status_check == 2 && leave_status === 0  ? <span><i className="icon icon-clock"></i>{moment(firstIntime, 'HH:mm').format('hh:mm a').toUpperCase()} </span> : ''}
            {status_check == 3 && leave_status === 0  ? <span><i className="icon icon-clock"></i>{moment(lastOuttime, 'HH:mm').format('hh:mm a').toUpperCase()}</span> : ''}
            {/* {status_check == 4 && <span><i className="icon icon-clock"></i>{totalMinut}</span>} */}
            {/* {(status_check == 5 && totalminuts<270) && <div className="table_btn absent1">Absent</div>} */}
            {/* {(status_check == 5 && totalminuts > 540) && <div className="table_btn present1">Present</div>} */}
            {/* {(status_check == 5 && (totalminuts < 540 && totalminuts > 270)) && <div className="table_btn halfday1">Halfday</div>} */}
        </>
    )
}

export default InOutComp



